const state = {
    workorderHistoryDataFields: [
        // {
        //     key: "workID",
        //     label: "工單",
        //     sortable: true,
        // },
        {
            key: "work_org_code",
            label: "工單",
            sortable: true,
        },
        {
            key: "processSchedule",
            label: "製程進度",
            sortable: true,
        },
        {
            key: "itemName",
            label: "料名",
            sortable: true,
        },
        {
            key: "qty",
            label: "派工數量",
            sortable: true,
        },
        {
            key: "time",
            label: "完工日期",
            sortable: true,
        }
    ],
    workorderHistoryDataItem: [],
    rowClickData: {},
    workorderHistoryTableStyle: "",
}
const getters = {
    get_workorderHistoryDataFields: state => {
        return state.workorderHistoryDataFields
    },
    get_workorderHistoryDataItem: state => {
        return state.workorderHistoryDataItem
    },
    get_rowClickData: state => {
        return state.rowClickData
    },
    get_workorderHistoryTableStyle: state => {
        return state.workorderHistoryTableStyle
    },
}
const actions = {
    set_workorderHistoryDataFields(context, array) {
        context.commit('SET_WORKORDERHISTORYDATAFIELDS', array);
    },
    set_workorderHistoryDataItem(context, array) {
        context.commit('SET_WORKORDERHISTORYDATAITEM', array);
    },
    set_rowClickData(context, obj) {
        context.commit('SET_ROWCLICKDATA', obj);
    },
    clear_workorderHistoryDataItem(context) {
        context.commit('CLEAR_WORKORDERHISTORYDATAITEM');
    },
    clear_rowClickData(context) {
        context.commit('CLEAR_ROWCLICKDATA');
    },
    set_workorderHistoryTableStyle(context, string = '') {
        context.commit('SET_WORKORDERHISTORYTABLESTYLE', string);
    },
}
const mutations = {
    SET_WORKORDERHISTORYDATAFIELDS(state, array) {
        state.workorderHistoryDataFields = array;
    },
    SET_WORKORDERHISTORYDATAITEM(state, array) {
        state.workorderHistoryDataItem = array;
    },
    SET_ROWCLICKDATA(state, obj) {
        state.rowClickData = obj;
    },
    CLEAR_WORKORDERHISTORYDATAITEM(state) {
        state.workorderHistoryDataItem = [];
    },
    CLEAR_ROWCLICKDATA(state) {
        state.rowClickData = {};
    },
    SET_WORKORDERHISTORYTABLESTYLE(state, string) {
        state.workorderHistoryTableStyle = string;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/workorderHistoryData.js